/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FavoriteListParams,
  Pagination,
  Favorite,
  FavoriteCreationParams,
  FavoriteRelatedObjectName
} from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class FavoriteService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  list(params?: FavoriteListParams): Observable<Pagination<Favorite>> {
    return this._httpClient.get<Pagination<Favorite>>(
      this._apiConstantsService.favoriteUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>,
        withCredentials: true
      }
    );
  }

  create(data: FavoriteCreationParams): Observable<Favorite> {
    return this._httpClient.post<Favorite>(
      this._apiConstantsService.favoriteUrl,
      data
    );
  }

  delete(favoriteId: string): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.favoriteUrl}/${favoriteId}`
    );
  }

  deleteByRelatedObject(relatedObject: {
    name: FavoriteRelatedObjectName;
    identifier: string;
  }): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.favoriteUrl}/${relatedObject.name}/${relatedObject.identifier}`
    );
  }

  deleteAllByRelatedObject(
    name: FavoriteRelatedObjectName
  ): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.favoriteUrl}/${name}/clear-all`
    );
  }
}
